import {CircularProgress} from "@mui/material";
import {useDeviceGetQuery} from "../../../app/api/api";
import {DeviceField} from "../../../app/api/model/device";
import QueryErrorAlert from "../../../components/QueryErrorAlert";
import DeviceCapabilities from "./DeviceCapabilities";

export default function DeviceCapabilitiesCell({deviceId}: {deviceId: number}) {
    const {data: device, isLoading, error} = useDeviceGetQuery(deviceId);

    if (error) {
        return <QueryErrorAlert error={error} />;
    }

    if (isLoading) {
        return <CircularProgress size={16} />;
    }

    return (
        <DeviceCapabilities
            capabilities={device?.[DeviceField.CAPABILITIES]}
            deviceModel={device?.[DeviceField.HARDWARE_TYPE]}
            showEmptyUi={!device}
            hideGps
        />
    );
}
